(() => {
  'use strict';
  if (window.mfEspressoGiftLayoutLoaded) return;
  window.mfEspressoGiftLayoutLoaded = true;

  function updateEspressoGift() {
    const root = document.getElementById('freegifts-main-popup-container');
    if (!root) return;
    const buttons = [...root.querySelectorAll('.bogos-gift-item-add-btn')];
    // Do not relabel or restyle other offers, including mixed-offer popups.
    const espressoOnly = buttons.length > 0 && buttons.every(button =>
      button.dataset.offer === '217943' &&
      button.closest('.bogos-offer-gift-item')?.querySelector('a[href*="/products/espresso-mug-"]')
    );
    if (!espressoOnly) {
      root.removeAttribute('data-mf-espresso-gift');
      root.querySelector('.mf-espresso-gift-note')?.remove();
      return;
    }
    root.setAttribute('data-mf-espresso-gift', '');
    const title = root.querySelector('#bogos-gift-popup-title');
    if (title && title.textContent !== 'Choose your complimentary espresso mug') {
      title.textContent = 'Choose your complimentary espresso mug';
    }
    if (title && !root.querySelector('.mf-espresso-gift-note')) {
      const note = document.createElement('p');
      note.className = 'mf-espresso-gift-note';
      note.textContent = 'Select one colour below to add your gift to your cart.';
      title.after(note);
    }
    // Native BOGOS controls, offer IDs, variants and pricing remain untouched.
  }

  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      updateEspressoGift();
    });
  });
  const start = () => {
    updateEspressoGift();
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
